<ng-template pTemplate="header">
  <!-- <i class="fa-solid fa-circle-xmark"></i>&nbsp; -->
  <div class="btn-custom">{{ isDownload ? '2. Restringir para ' : '4. Estoque restrito' }}</div>
</ng-template>

<div class="col-12 md:col-12" *ngIf="!isDownload">
  <div class="flex flex-column gap-2">
    <label for="print-batch-quantity mb-2">Quantidade</label>
    <p-inputNumber inputId="print-batch-quantity" [showButtons]="true" buttonLayout="horizontal" [allowEmpty]="false"
      [(ngModel)]="currentTotal" (ngModelChange)="onChangeTotal()" [disabled]="isConfirmed" [min]="0"
      spinnerMode="horizontal" incrementButtonIcon="fa-solid fa-plus" decrementButtonIcon="fa-solid fa-minus"
      class="w-full"></p-inputNumber>
  </div>
</div>
<div *ngIf="!isConfirmed">
  <distribution-importfile [titleDownloadFile]="isDownload
        ? 'Modelo de planilha para restrição de download'
        : 'Modelo de planilha para estoque restrito'"
    [filePathToDownload]="isDownload ? '/assets/docs/modelo_importacao_download_restrito.xlsx' : '/assets/docs/modelo_importacao_estoque_restrito.xlsx'"
    [isConfirmed]="isConfirmed" [isLoading]="isLoading"
    (parsedData)="handleParsedData($event)"></distribution-importfile>
</div>

<div class="card">
  <p-toolbar aria-label="Actions" styleClass="mb-6">
    <div class="p-toolbar-group-left">Configuração da distribuição de estoque restrito</div>
    <div class="p-toolbar-group-right">
      <p-button text label="Remover" icon="pi pi-trash" styleClass="p-button-warning" outlined
        [disabled]="!selectedDistribution || !selectedDistribution.length"
        (onClick)="deleteSelectedProductionItens($event)" />
    </div>
  </p-toolbar>

  <p-table [value]="Itens" [dataKey]="'id'" styleClass="p-datatable-striped mb-3"
    [tableStyle]="{ 'min-width': '50rem' }" *ngIf="Itens.length > 0" [(selection)]="selectedDistribution"
    selectionMode="multiply">
    <ng-template pTemplate="header">
      <tr>
        <th class="cursor-default" style="width: 4rem">
          <p-tableHeaderCheckbox [disabled]="isConfirmed" />
        </th>
        <th class="cursor-default" style="width: 300px">Prefixo</th>
        <th class="cursor-default" style="width: 100px" *ngIf="!isDownload">Quantidade</th>
        <th class="cursor-default" style="width: 40px">Ação</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-distribution let-i="rowIndex">
      <tr>
        <td>
          <p-tableCheckbox [value]="distribution" [disabled]="isConfirmed" />
        </td>
        <td class="cursor-default">
          {{ distribution.detail.label }}
        </td>
        <td *ngIf="!isDownload">
          <p-inputNumber *ngIf="!isDownload" inputId="print-batch-quantity" [(ngModel)]="distribution.quantity"
            [showButtons]="true" [disabled]="isConfirmed" buttonLayout="horizontal" (ngModelChange)="onChangeData()"
            [allowEmpty]="false" [min]="0" spinnerMode="horizontal" [disabled]="isLoading || isConfirmed"
            incrementButtonIcon="fa-solid fa-plus" decrementButtonIcon="fa-solid fa-minus"
            class="w-full"></p-inputNumber>
        </td>
        <td>
          <p-button icon="fa-solid fa-times" styleClass="p-button p-button-danger p-button-text" pTooltip="Remover"
            [disabled]="isConfirmed" tooltipPosition="left"
            (onClick)="removeDeliveryWayRestrict($event, distribution, i)"></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="p-fluid grid formgrid" *ngIf="!isConfirmed">
  <div class="field col-12 md:col-12">
    <label for="print-batch-restricted-prefix3" [class.required]="deliveryWayRestrict.length === 0">
      Prefixo</label>
    <p-autoComplete id="print-batch-restricted-prefix3" [(ngModel)]="printBatchRestrictedPrefix"
      [suggestions]="printBatchRestrictedPrefixOptions" (completeMethod)="filterDeliveryWayRestrict($event)"
      field="label" (onSelect)="addDeliveryWayRestrict($event)"></p-autoComplete>
    <small class="cursor-default">Digite o prefixo da dependência de destino ou algo similar. Pode usar o teclado, é
      mais
      fácil. Para escolher pressione a tecla Enter.</small>
  </div>
</div>